import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { RouteConstants } from '../../../../../../core/constants/routes';
import { ReturnRouteService } from '../../../../../../core/services/navigation/return-route.service';
import { OrderIdCellRendererParams } from './models/order-id-cell-renderer-params';

@Component({
    selector: 'app-order-id-cell-renderer',
    templateUrl: './order-id-cell-renderer.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [],
})
export class OrderIdCellRendererComponent implements ICellRendererAngularComp {
    params!: OrderIdCellRendererParams;

    constructor(
        private readonly router: Router,
        private readonly returnRouteService: ReturnRouteService,
    ) {}

    agInit(params: OrderIdCellRendererParams): void {
        this.params = params;
    }

    refresh(): boolean {
        return false;
    }

    navigate(): void {
        this.returnRouteService.set(this.params.returnRoute ?? null);
        this.router.navigate([this.getRouterLink()]);
    }

    getRouterLink(): string {
        return RouteConstants.Order.getOrderSummaryRoute(this.params.value);
    }
}
